import UserService from '@services/UserService';
import { Button, Upload, Spin } from 'antd';
import { Storage } from 'aws-amplify';
import AWS from 'aws-sdk';
import React from 'react';
import uuidv4 from 'uuidv4';
import PdfToPng from '../helpers/PdfToPng'

import I18n from '../i18n';
import styled, { Theme } from '../styled-components';
import { TypesValidation } from '@src/helpers/Enums';

type PropType = {
  isRequired?: boolean;
  buttonTitle?: string;
  customListType?: "picture" | 'picture-card' | 'text' | undefined;
  defaultFileList?: any;
  onFileListChange?: any;
  onValidate?: Function;
  onRemoveImage?: Function;
  validateUpload?: any;
  accept?: string;
  isStorage?: boolean
  directory?: string;
  isLoadingFile?: any;
  formatImageList?: Function;
  handleUpdateSortableListKey?: Function;
  type: string;
};

type StateType = {
  fileList: any[];
  defaultFileList: any;
  bucket: string;
  path: string;
  isLoading: boolean;
  preparingFile: boolean;
};

export default class UploadComponent extends React.Component<PropType, StateType> {

  private _userService: UserService;

  constructor(props: PropType) {
    super(props);

    this.state = {
      fileList: [],
      defaultFileList: [],
      bucket: '',
      path: '',
      isLoading: false,
      preparingFile: false
    }

    this.onChange = this.onChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this._userService = new UserService();
    this.handleDownload = this.handleDownload.bind(this)
    this.configure = this.configure.bind(this)
    this.onRemove = this.onRemove.bind(this)
  }

  async configure() {
    const { defaultFileList, onFileListChange } = this.props;
    if (defaultFileList && Array.isArray(this.props.defaultFileList) && this.props.defaultFileList.length > 0) {
      await this.setState({
        defaultFileList: {
          fileList: this.props.defaultFileList[0],
          path: this.props.defaultFileList[0].url
        },
        fileList: [this.props.defaultFileList[0]],
        path: this.props.defaultFileList[0].url
      })
    }
    if (defaultFileList && defaultFileList.fileList && !Array.isArray(defaultFileList.fileList) && (this.props.defaultFileList)) {
      await this.setState({
        defaultFileList: {
          fileList: this.props.defaultFileList.fileList,
          path: this.props.defaultFileList.valuel
        },
        fileList: [this.props.defaultFileList.fileList],
        path: this.props.defaultFileList.value
      })
      onFileListChange(defaultFileList.value, false, defaultFileList.fileList);
    }
  }

  componentWillMount() {
    this.configure()
  }

  componentDidMount() {
    const { onValidate } = this.props;
    if (onValidate) onValidate(this.validateField);
    this.setState({ bucket: 'https://' + Storage._options.bucket + '/public/' })
  }

  onChange = async (value: any) => {
    const storage = JSON.parse(localStorage.getItem('clientUpload') || '');
    const userAccessKey = await this._userService.getAccessAWS('s3');

    AWS.config.update({
      accessKeyId: userAccessKey.AccessKeyId,
      secretAccessKey: userAccessKey.SecretAccessKey,
      sessionToken: userAccessKey.SessionToken,
      region: "us-east-1",
    });

    if (this.props.isStorage) {
      if (value.fileList.length === 0) {
        this.props.onFileListChange('', false, '');
        return false
      }

      let typeFile = value.file.type.split('/')
      await this.setState({ isLoading: true })
      this.props.onFileListChange(this.state.path, true, false)
      if (this.props.isLoadingFile) {
        this.props.isLoadingFile(this.state.isLoading);
      }
      const directory = this.props.directory ? this.props.directory : typeFile[0] !== "" ? typeFile[0] : 'files/data-files';

      const s3 = new AWS.S3();
      const params = {
        ACL: 'public-read',
        Body: value.file,
        Bucket: `${storage.bucket}/${directory}`,
        ContentType: value.file.type,
        Key: `${Date.now().toString()}${(typeFile[1] ? '.' + typeFile[1] : this.props.accept)}`
      };
      const response = await s3.upload(params).promise();
      await this.setState({
        path: response.Location,
        isLoading: false
      })
      this.props.onFileListChange(this.state.path, this.state.isLoading, value.file);
      if (this.props.isLoadingFile) {
        this.props.isLoadingFile(this.state.isLoading);
      }
      if (this.props.formatImageList) this.props.formatImageList()
      this.configure()
      if (this.props.onValidate) this.props.onValidate(this.validateField);
      if (this.props.handleUpdateSortableListKey) this.props.handleUpdateSortableListKey()
    }
    else {
      let imgData;
      if (value.file) {
        if (value.file.status != "removed") {
          this.getBase64(value.file, (imageUrl: string) => {
            imgData = imageUrl.substr(imageUrl.indexOf(',') + 1);
            this.props.onFileListChange(imgData, this.state.isLoading, value.file);
          });
        }
      }

      await this.setState({ fileList: value.fileList });
      if (this.props.validateUpload) this.props.validateUpload(value.fileList)
    }

  }

  onRemove(file: any) {
    if (this.props.onRemoveImage) this.props.onRemoveImage();
    this.setState(({ fileList }) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      return {
        fileList: newFileList,
        path: this.props.type ? '' : this.state.path
      };
    })
  }

  getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  validateField = (rule: any, value: any, callback: any) => {
    const { isRequired } = this.props;
    const { fileList } = this.state;
    if (isRequired) {
      if (fileList.length == 0) {
        callback(I18n.l('form.validation.image.required'));
        return;
      }
    }
    callback();
  }

  toDataURL(url: string) {
    return fetch(url).then((response) => {
      return response.blob();
    }).then(blob => {
      return URL.createObjectURL(blob);
    });
  }

  async handleDownload(file: any) {
    this.setState({ preparingFile: true })
    try {
      const a = document.createElement("a")
      a.href = await this.toDataURL(file.url)
      a.download = uuidv4()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      this.setState({ preparingFile: false })
    } catch (e) {
      this.setState({ preparingFile: false })
    }
  }

  render() {
    const {
      customListType,
      accept
    } = this.props;

    const {
      fileList,
      defaultFileList
    } = this.state;

    const imgUploadBtnSpace = fileList.length > 0 ? "hide-btn-space" : "";
    const imgUploadBtnHidder = fileList.length > 0 ? "upload-img-hide" : "upload-img-show";
    return (
      <Wrapper>
        <Upload
          accept={accept ? accept : '.png, .jpg, .jpeg, .pdf'}
          action="//jsonplaceholder.typicode.com/posts/"
          className={`upload-list-inline ${imgUploadBtnSpace}`}
          defaultFileList={defaultFileList && !Array.isArray(defaultFileList) && [defaultFileList.fileList] ? [defaultFileList.fileList] : []}
          listType={customListType != undefined ? customListType : 'text'}
          onRemove={this.onRemove}
          onChange={this.onChange}
          onPreview={this.handleDownload}
          onDownload={this.handleDownload}
          beforeUpload={(file: any) => {
            this.setState(({ fileList }) => ({
              fileList: [...fileList, file],
            }));
            return false;
          }}
        >
          <Button style={{ width: '100%' }} className={`upload-btn ${imgUploadBtnHidder} `}>
            {I18n.l('labels.uploadTitle')}
            <p className='b'>{I18n.l('labels.uploadSubtitle')}</p>
          </Button>
        </Upload>
        {this.state.path.toLocaleLowerCase().includes('.pdf') && this.props.type === TypesValidation.IMAGE && <PdfToPng pdfUrl={this.state.path}/>}
        {((this.state.isLoading && fileList.length > 0) || this.state.preparingFile) && <Spin />}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    width: 100%;   

    .upload-btn{
        height: 80px;
        margin-top: 0px;
        border: dashed 2px ${Theme.secondary.midLightGrey};
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .ant-btn{
      color: ${Theme.secondary.grey}
    }

    .ant-upload-list-item-info{
        display:flex;
        align-items: center;
        height:100%;        
    }
    .ant-upload {
      width: 100%;
      
  }

    .ant-upload-list-picture .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
        top: 5px;
    }

    /* tile uploaded pictures */
    .upload-list-inline .ant-upload-list-item {
        width: 200px;
        margin-right: 8px;
        margin-top: 0px;
        width: 300px;
        height: 60px;   
        text-align : center;    
    }
    .upload-list-inline .ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }
    .upload-list-inline .ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }    

    .hide-btn-space .ant-upload.ant-upload-select{
        display:none;   
    }    
    
    .upload-img-hide{
        display:none;
    }
    .upload-img-show{
        
    }
`;
